import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(protected)/admin/(content)/emergency-broadcast": [6],
		"/admin/feedbacks/[id]": [8],
		"/(protected)/admin/(content)/ml-scanner": [7],
		"/ai-workflow": [9],
		"/alerts": [10],
		"/alerts/[id]": [11,[],[2]],
		"/analytics/energy-forecast": [12],
		"/approved-alerts": [13],
		"/dashboard": [14],
		"/dashboard/admin": [15],
		"/feedback": [16],
		"/field-tech": [17,[3]],
		"/field-tech/alerts": [18,[3]],
		"/field-tech/profile": [19,[3]],
		"/field-tech/schedule": [20,[3]],
		"/field-tech/session/[id]": [21,[3]],
		"/field-tech/tracking": [22,[3]],
		"/field-tech/work-orders": [23,[3]],
		"/field-tech/work-orders/[id]": [24,[3]],
		"/login": [25],
		"/logs": [26],
		"/ml-predictions": [27],
		"/my-feedback": [28],
		"/my-feedback/[id]": [29],
		"/password-reset": [30],
		"/profile": [31],
		"/reset-password": [~32],
		"/work-orders": [33],
		"/work-orders/[id]": [34,[],[4]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';